export default class Search {
    constructor() {
        const searches = document.querySelectorAll<HTMLElement>('.search')
        for (const search of searches) {
            new SearchInstance(search)
        }
    }
}

class SearchInstance {
    private container: HTMLElement
    private input: HTMLInputElement | null

    constructor(container: HTMLElement) {
        this.container = container
        this.input = container.querySelector<HTMLInputElement>('input[type="search"]')

        // guard against a double-bound listener (e.g. HMR re-init), which would move focus twice
        if (container.dataset.searchBound) return
        container.dataset.searchBound = 'true'
        this.container.addEventListener('keydown', (event) => this.onKeydown(event))

        // clear suggestions when focus leaves this search (e.g. opening the menu over the search page)
        this.container.addEventListener('focusout', (event) => {
            const next = event.relatedTarget as Node | null
            if (!next || !this.container.contains(next)) {
                this.clearSuggestions()
            }
        })
    }

    // suggestions are patched in by datastar, so resolve them at event time
    private get options(): HTMLAnchorElement[] {
        return Array.from(this.container.querySelectorAll<HTMLAnchorElement>('[role="option"] a'))
    }

    private onKeydown(event: KeyboardEvent) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Escape') return

        // a stray duplicate listener would handle the same event again and move focus twice;
        // mark the event so only the first listener acts
        const marked = event as KeyboardEvent & {searchHandled?: boolean}
        if (marked.searchHandled) return
        marked.searchHandled = true

        if (event.key === 'Escape') {
            this.clearSuggestions()
            this.input?.focus()
            return
        }

        const options = this.options
        if (!options.length) return
        event.preventDefault()

        const currentIndex = options.findIndex((option) => option === document.activeElement)

        if (event.key === 'ArrowDown') {
            const next = currentIndex === -1 ? options[0] : options[currentIndex + 1] ?? options[0]
            next.focus()
        } else {
            if (currentIndex === -1) {
                options[options.length - 1].focus()
            } else if (currentIndex === 0) {
                this.input?.focus()
            } else {
                options[currentIndex - 1].focus()
            }
        }
    }

    private clearSuggestions() {
        const list = this.container.querySelector<HTMLElement>('[id^="search-suggestions-"]')
        if (list) list.innerHTML = ''
    }
}
